import { connect } from 'react-redux';
import Searchbox from './SearchBox';

const mapStateToProps = ({
  content: { searchbox },
  intl: { locale },
  system: { siteName, siteDomain, isMobile }
}) => ({
  domain: siteDomain,
  site: siteName,
  locale,
  isMobile,
  ...searchbox
});

export default connect(mapStateToProps)(Searchbox);
